import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Text } from 'xen-ui';
import { COMPANY_NAME } from 'xen/constants';
import { AppLayoutDivider } from '../divider';
const Footer = () => {
    return (_jsxs(Box, { bg: "var(--app-shell-color-bg)", component: "footer", children: [_jsx(AppLayoutDivider, {}), _jsxs(Text, { px: "md", py: "xs", size: "sm", children: ["Copyright \u00A9 ", new Date().getFullYear(), ", ", COMPANY_NAME] })] }));
};
export { Footer };
